"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselFooter", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselFooter = require("./useTeachingPopoverCarouselFooter");
const _renderTeachingPopoverCarouselFooter = require("./renderTeachingPopoverCarouselFooter");
const _useTeachingPopoverCarouselFooterStylesstyles = require("./useTeachingPopoverCarouselFooterStyles.styles");
const TeachingPopoverCarouselFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselFooter.useTeachingPopoverCarouselFooter_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselFooterStylesstyles.useTeachingPopoverCarouselFooterStyles_unstable)(state);
    return (0, _renderTeachingPopoverCarouselFooter.renderTeachingPopoverCarouselFooter_unstable)(state);
});
TeachingPopoverCarouselFooter.displayName = 'TeachingPopoverCarouselFooter';
